/**
 * Coordinate conversion between screen (pixel) and logical space.
 * Logical space is fixed (e.g. 1000x800) so tutor and student stay aligned
 * regardless of display size.
 */

import { LOGICAL_WIDTH, LOGICAL_HEIGHT } from './constants';

/**
 * Convert screen (pixel) coordinates to logical coordinates.
 * @param {number} x - Screen x
 * @param {number} y - Screen y
 * @param {number} canvasWidth - Canvas element width in pixels
 * @param {number} canvasHeight - Canvas element height in pixels
 * @returns {{ x: number, y: number } | null} Logical coords, or null if dimensions invalid
 */
export function screenToLogical(x, y, canvasWidth, canvasHeight) {
  if (
    typeof canvasWidth !== 'number' ||
    typeof canvasHeight !== 'number' ||
    !Number.isFinite(canvasWidth) ||
    !Number.isFinite(canvasHeight) ||
    canvasWidth <= 0 ||
    canvasHeight <= 0 ||
    typeof x !== 'number' ||
    typeof y !== 'number' ||
    !Number.isFinite(x) ||
    !Number.isFinite(y)
  ) {
    return null;
  }
  return {
    x: (x / canvasWidth) * LOGICAL_WIDTH,
    y: (y / canvasHeight) * LOGICAL_HEIGHT,
  };
}

/**
 * Convert logical coordinates to screen (pixel) coordinates.
 * @param {number} x - Logical x
 * @param {number} y - Logical y
 * @param {number} canvasWidth - Canvas element width in pixels
 * @param {number} canvasHeight - Canvas element height in pixels
 * @returns {{ x: number, y: number } | null} Screen coords, or null if dimensions invalid
 */
export function logicalToScreen(x, y, canvasWidth, canvasHeight) {
  if (
    typeof canvasWidth !== 'number' ||
    typeof canvasHeight !== 'number' ||
    !Number.isFinite(canvasWidth) ||
    !Number.isFinite(canvasHeight) ||
    canvasWidth <= 0 ||
    canvasHeight <= 0 ||
    typeof x !== 'number' ||
    typeof y !== 'number' ||
    !Number.isFinite(x) ||
    !Number.isFinite(y)
  ) {
    return null;
  }
  return {
    x: (x / LOGICAL_WIDTH) * canvasWidth,
    y: (y / LOGICAL_HEIGHT) * canvasHeight,
  };
}
